import { selectAccount } from '@bonanza-social/account';
import { getWelcomePromos } from '@bonanza-social/promos';
import { accountStatusUpdated, startListening } from '@bonanza-social/toolkit/state';

startListening({
  actionCreator: accountStatusUpdated,
  effect: (_, { dispatch, getState }) => {
    const account = selectAccount(getState());
    if (account?.statusReason === 'KYC incomplete') {
      dispatch(getWelcomePromos());
    }
  },
});
